document.addEventListener('DOMContentLoaded', function () {
    // Size mapping logic
    const swatchItems = document.querySelectorAll('.swatches-select .nt-swatch');
    const sizeInfoElements = document.querySelectorAll('.swatch .size_info_f');
    const sizeMapping = {
        "XXS": " - US: 0, AU: 4, UK: 4, EU: 32",
        "XS": " - US: 2, AU: 6, UK: 6, EU: 34",
        "S": " - US: 4, AU: 8, UK: 8, EU: 36",
        "M": " - US: 6, AU: 10, UK: 10, EU: 38",
        "L": " - US: 8, AU: 12, UK: 12, EU: 40",
        "XL": " - US: 10, AU: 14, UK: 14, EU: 44",
        "XXL": " - US: 12, AU: 16, UK: 16, EU: 50"
    };

    // Initialize size info
    sizeInfoElements.forEach((element) => {
        const defaultValue = element.closest('.swatch').querySelector('.nt_name_current').textContent.trim();
        element.textContent = sizeMapping[defaultValue] || "";
    });

    // Update size info on swatch click
    swatchItems.forEach((item) => {
        item.addEventListener('click', function () {
            const selectedValue = this.getAttribute('data-escape');
            const sizeInfoElement = this.closest('.swatch').querySelector('.size_info_f');
            sizeInfoElement.textContent = sizeMapping[selectedValue] || "No matching size info";
        });
    });

    // Stock availability logic
    const stockDataElement = document.getElementById('stockData'); // JSON data element
    const availableSizesElement = document.getElementById('availableSizes'); // Output area
    let sizesAvailableToday = []; // Array to hold eligible sizes

    // Parse JSON stock data
    const stockData = JSON.parse(stockDataElement.textContent);

    // Check stock conditions
    stockData.forEach(item => {
        const size = item.value;
        const quantity = item.quantity;

        if (quantity > 0 && quantity < 5) {
            sizesAvailableToday.push(size); // Add eligible sizes
        }
    });

    // Generate display content
    if (sizesAvailableToday.length > 0) {
        availableSizesElement.textContent = `${sizesAvailableToday.join(', ')} can be shipped today`; // Output sizes
    } else {
        availableSizesElement.textContent = ""; // Fallback message
    }
});
